<template>
  <v-row>
    <v-col>
      <div v-if="!showWindow">
        <h1 class="not-found__name">404</h1>
        <span class="not-found__text">Страница не найдена</span>
        <div class="not-found__btn-container">
          <v-btn class="green-button white--text mt-6" @click="goBack()"
            >На главную</v-btn
          >
        </div>
        <div class="mt-4 helvetica-medium mr-3 fs-18 mt-1">
          <v-text-field v-model="inputCode" />
        </div>
      </div>
      <div v-if="showWindow">
        <div class="tes-card__title d-flex">Проверка функционала ЕСИА</div>
        <div class="tes-card__title font-italic d-flex">
          Здесь вы можете проверить работу функционала ЕСИА
        </div>
        <v-row>
<div class="form-border mt-5">
            <div class="form-buttons">
              <span class="red--text mt-2 ml-10"><span class="blue--text">ГОС</span>УСЛУГИ</span>
            </div>
            <div class="form-buttons">
              <v-btn
                @click="doLoginESIA()"
                dark
                class="green-button white--text mt-6 mb-2"
                width="320"
                large
                :loading="loading"
                >Войти через ЕСИА
              </v-btn>
            </div>
            </div>
        </v-row>
      </div>
      <modal-payment
        v-if="showModalPayment"
        v-model="showModalPayment"
        :toPay="sumPay"
        :personalAccount="personalAccount"
        :idAccount="idAccount"
      />
      <modal-account-found-error v-if="showWindowError" v-model="showWindowError"/>
    </v-col>
  </v-row>
</template>
<script>
import GuestReadingInstructions from "@/components/guest/GuestReadingInstructions";
import { mapState } from "vuex";
import { AxiosWrapper } from "../../assets/api/AxiosWrapper";
import ModalAccountFoundError from '../../components/modals/ModalAccountFoundError.vue';
import ModalPayment from "../../components/modals/ModalPaymentForComission";

export default {
  layout: "guest",
  name: "guest-payments",
  data: () => ({
    inputCode: "",
    showWindow: false,
    personalAccount: "",
    sumPay: "",
    loading: false,
    idAccount: "",
    showWindowError: false,
    showModalPayment: false,
  }),
  components: 
  {
    ModalAccountFoundError,
    ModalPayment
  },
  computed: {},
  methods: {
    goBack() {
      if (this.inputCode === "testes7") {
        this.showWindow = true;
      } else {
        this.$router.push({ path: "/authorization" });
      }
    },

    getAccount() {
      this.loading = true;
      this.$store
        .dispatch("guest/getAccount", {
          ls: this.personalAccount,
        })
        .then((response) => {
          if (response.success && response.isExist) 
          {
            this.idAccount = response.guid;
            this.showModalPayment = true;
           // this.GetBankUrl();
          } 
          else 
          {
            this.showWindowError = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
 doLoginESIA() {
      this.loading = true;

      this.$store
        .dispatch("account/getEsiaURL")
        .then((response) => {
          if (response.data.success) {
            location.href = response.data.url;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    GetBankUrl() {
      this.loading = true;
      let postData = {
        appVersion: 'LKFL',
        personalAccount: this.personalAccount,
        idAccount: this.idAccount,
        paySum: this.sumPay,
      };

      AxiosWrapper.post("GetBankUrl", postData)
        .then((response) => {
          if (response.data.success) {
            // console.log(response.data)
            // return;
            window.open(response.data.url, "_top");
          } else {
            this.$store.commit("common/" + "ADD_ALERT", {
              type: "error",
              text: response.data.message || "Произошла ошибка!",
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {},
};
</script>
<style scoped>
.form-border{
  border-width:0;
border-color: rgb(0, 94, 255);
border-radius: 20px;
border-style: solid;
font-size: 25px;
}

.not-found__name {
  display: block;
  font-weight: bold;
  font-size: 96px;
  text-align: center;
}
.not-found__text {
  display: block;
  font-weight: bold;
  font-size: 48px;
  text-align: center;
}

.not-found__btn-container {
  display: flex;
  justify-content: center;
}

.not-found__btn {
  margin-top: 25px;
  display: block;
}
</style>
